import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { NewsTypeTermsQuery } from '@custom/schema';

export const useNewsTypesTermsQuery = () =>
  useStaticQuery(graphql(NewsTypeTermsQuery));
